import { useCallback, useMemo } from "react";
import { P2TextDescription } from "react-bootstrap-common-script";
import FilterLeftSvg from "../../../assets/svg/filter-left";
import { DocumentItem, FileItem } from "../../../models/polymer/Document.model";
import { Helpers } from "../../../utils/helper";
import { downloadFile } from "../../../utils/download-file";
import { useAppSelector } from "../../../redux/hook";
import { uniq } from "lodash";
interface ReviewDocumentProps {
  document_list?: DocumentItem[];
  file_items?: FileItem[];
  submitted_documents_code?: string[];
  allowDownload?: boolean;
}
function ReviewDocument({
  document_list = [],
  file_items = [],
  submitted_documents_code = [],
  allowDownload=true,
  ...props
}: ReviewDocumentProps) {
  const formatSize = useCallback((size: number) => {
    return Helpers.formatBytesToMB(size);
  }, []);
  const singpassToken = useAppSelector(state => state.auth.AuthenticationSlice.singpassToken);

  const handleDownload = useCallback((key: string) => () => {
    if(allowDownload) {
      console.log("downloading:", key);
      downloadFile(key, singpassToken);
    }
}, [singpassToken, allowDownload])

  const fileLabels = useMemo(() => {
      return uniq(file_items.map(item => item.label));
  }, [file_items])

  return (
    <div className="polymer-uploaded-documents-container">
      <div className="polymer-uploaded-documents-title">
        <P2TextDescription color="#000" title="Uploaded Documents" />
      </div>
      {fileLabels.map((label, _index) => {
        const files = file_items.filter((file) => file.label === label);
        const fileDetail = document_list.find(doc => doc.code === (files.length > 0 ? files[0].code : ""));
        const totalSize =
          files
            .map((item) => item.file_content.size)
            .reduce((a, b) => (a ?? 0) + (b ?? 0), 0) ?? 0;

        const formattedTotalSize = formatSize(totalSize);

        return (
          <div aria-disabled={true} className="polymer-uploaded-document" key={fileDetail?.code ?? ""}>
            <div
              style={{
                borderBottom:
                  _index !== document_list.length - 1
                    ? "1px dashed #0C8188"
                    : "",
                padding: "32px 0",
              }}
            >
              <div style={{ marginBottom: "7px" }}>
                <P2TextDescription
                  size="18px"
                  color="#000"
                  title={label}
                />
              </div>
              <div className="polymer-document-details">
                <div className="polymer-stages-flow-item__content-container__title-description polymer-review-document-description">
                  <P2TextDescription
                    color={"#575757"}
                    description={fileDetail?.description ?? ""}
                  />
                </div>
                <div className="polymer-file-selection-container polymer-summary-uploaded-file-container">
                  {files.map((file, _fileIndex) => {
                    const key = _fileIndex;
                    return (
                      <div
                        className="polymer-file-selection-segment__file-container"
                        key={key}
                      >
                        <div>
                          <FilterLeftSvg />
                        </div>
                        <div>
                          <p className="m-0" style={{cursor: allowDownload ? "pointer" : "default"}} onClick={handleDownload(file.key)}>{file.file_content.file_name}</p>
                          <p className="m-0">{`(${formatSize(
                            file.file_content.size ?? 0
                          )} MB)`}</p>
                        </div>
                      </div>
                    );
                  })}
                  <p className="polymer-document-total-file-size">
                    Total file size:{" "}
                    <span className="size">{formattedTotalSize} MB</span>/10 MB
                  </p>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default ReviewDocument;
